module.exports = __webpack_public_path__ + "img/Icon material-location-on.a7e63f8d.svg";